import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Header from 'src/components/header';
import Loader from 'src/components/loader';
import NotFound from 'src/components/not-found';
import { TOOLING_STOCK_ACTION_TYPES } from 'src/utils/constants';
import routes from 'src/utils/routes';
import useQueryParams, { getRouteURI } from 'src/utils/url';
import userPropType from 'src/utils/user-prop-type';

const ToolActionPage = ({ user }) => {
  const [actionNotFound, setActionNotFound] = useState(false);
  const { uuid: id } = useParams();
  const {
    type,
    runUUID,
    toolingStockUUID,
  } = useQueryParams();
  const navigate = useNavigate();

  useEffect(() => {
    let pageName = null;
    const queryParams = {};


    switch (type) {
      case TOOLING_STOCK_ACTION_TYPES.PUT_INTO_USE:
        pageName = 'put-into-use';
        queryParams.runUUID = runUUID;
        queryParams.toolingStockUUID = toolingStockUUID;
        queryParams.initialAction = TOOLING_STOCK_ACTION_TYPES.PUT_INTO_USE;
        break;
      default:
        setActionNotFound(true);
        break;
    }

    if (pageName) {
      navigate(getRouteURI(
        `${routes.toolAction}/${pageName}`, { uuid: id }, queryParams),
        { replace: true });
    }

  }, [type]);

  if (actionNotFound) {
    return (
      <>
        <Header excludeFromHistory title="Tool Action Not Found" user={user} />
        <main role="main" className="text-center">
          <NotFound id={id} />
        </main>
      </>
    );
  }

  return (
    <>
      <Header title="Tool Action" user={user} />
      <main role="main" className="text-center">
        <Loader />
      </main>
    </>
  );
};

ToolActionPage.propTypes = {
  user: userPropType,
};

ToolActionPage.defaultProps = {
  user: null,
};

export default ToolActionPage;
